/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Err_Same_PositionInputs */

const vi_pdc_err_same_position = /** @type {(inputs: Pdc_Err_Same_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí đích phải khác vị trí hiện tại của lô`)
};

/**

* @param {Pdc_Err_Same_PositionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_err_same_position = /** @type {((inputs?: Pdc_Err_Same_PositionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Err_Same_PositionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_err_same_position(inputs)
});